(function (root) {
"use strict";
var K = root.SDRKit, T = K && K.tej;
if (!T || !K.A) return;
var CW = T.CW, CH = T.CH;
/* guarda la definición de cada diseño del kit para poder volver a tejerlo con otra puntada */
if (K.registrar && !K._D) { var reg = K.registrar; K._D = {}; K.registrar = function (D) { K._D[D.id] = D; return reg.apply(this, arguments); }; }
function paleta(px, n, k) {
var c = [], i, j, it, ord = [];
for (i = 0; i < n; i++) ord.push(i);
ord.sort(function (a, b) { return (px[a * 4] * .3 + px[a * 4 + 1] * .59 + px[a * 4 + 2] * .11) - (px[b * 4] * .3 + px[b * 4 + 1] * .59 + px[b * 4 + 2] * .11); });
for (i = 0; i < k; i++) { var q = ord[Math.min(n - 1, Math.floor((i + .5) / k * n))]; c.push([px[q * 4], px[q * 4 + 1], px[q * 4 + 2]]); }
var asig = new Uint8Array(n), err = 0;
for (it = 0; it < 10; it++) {
var s = c.map(function () { return [0, 0, 0, 0]; }); err = 0;
for (i = 0; i < n; i++) {
var r = px[i * 4], g = px[i * 4 + 1], b = px[i * 4 + 2], best = 0, bd = 1e9;
for (j = 0; j < k; j++) { var dr = r - c[j][0], dg = g - c[j][1], db = b - c[j][2], dd = dr * dr * .3 + dg * dg * .59 + db * db * .11; if (dd < bd) { bd = dd; best = j; } }
asig[i] = best; err += Math.sqrt(bd); s[best][0] += r; s[best][1] += g; s[best][2] += b; s[best][3]++;
}
for (j = 0; j < k; j++) if (s[j][3]) c[j] = [s[j][0] / s[j][3], s[j][1] / s[j][3], s[j][2] / s[j][3]];
}
return { c: c, asig: asig, err: err / Math.max(1, n) };
}
T.paleta = paleta;
/* cuántos colores necesita la imagen: el menor número que la reproduce bien */
T.paletaIdeal = function (px, n, kmin, kmax) {
var P = null;
for (var k = kmin || 5; k <= (kmax || 12); k += 2) { P = paleta(px, n, k); if (P.err < 11) return P; }
return P;
};
/* luminancia y máscara de un lienzo (alfa > 110 = dentro) */
T.lumMascara = function (d, w, h) {
var n = w * h, L = new Float32Array(n), Mk = new Uint8Array(n), i;
for (i = 0; i < n; i++) { L[i] = d[i * 4] * .299 + d[i * 4 + 1] * .587 + d[i * 4 + 2] * .114; Mk[i] = d[i * 4 + 3] > 110 ? 1 : 0; }
return { L: L, M: Mk };
};
/* textura adaptable: cuántas puntadas a lo ancho necesita la imagen para que se distinga.
   Prueba de grueso a fino y se queda con la más gruesa que conserva la estructura de la foto
   (similitud estructural, dando más peso a las zonas con detalle: ojos, nariz, manchas, letras). */
function caja(a, w, h, r) {
var t = new Float32Array(w * h), o = new Float32Array(w * h), x, y, s, n = 2 * r + 1;
for (y = 0; y < h; y++) { s = 0; for (x = -r; x <= r; x++) s += a[y * w + Math.min(w - 1, Math.max(0, x))]; for (x = 0; x < w; x++) { t[y * w + x] = s / n; s += a[y * w + Math.min(w - 1, x + r + 1)] - a[y * w + Math.max(0, x - r)]; } }
for (x = 0; x < w; x++) { s = 0; for (y = -r; y <= r; y++) s += t[Math.min(h - 1, Math.max(0, y)) * w + x]; for (y = 0; y < h; y++) { o[y * w + x] = s / n; s += t[Math.min(h - 1, y + r + 1) * w + x] - t[Math.max(0, y - r) * w + x]; } }
return o;
}
function suave(a, w, h, r) { return caja(caja(a, w, h, r), w, h, r); }
T.pasoIdeal = function (L0, Mk, w, h, nMin, nMax, tau) {
var N = w * h, i, tot = 0, cnt = 0;
for (i = 0; i < N; i++) if (Mk[i]) { tot += L0[i]; cnt++; }
if (cnt < 40) return nMin;
var media = tot / cnt, L = new Float32Array(N);
for (i = 0; i < N; i++) L[i] = Mk[i] ? L0[i] : media;
var ref = caja(L, w, h, 1), r = Math.max(2, Math.round(w / 80)), C2 = 58.5;
var ref2 = new Float32Array(N); for (i = 0; i < N; i++) ref2[i] = ref[i] * ref[i];
var mu1 = suave(ref, w, h, r), v1 = suave(ref2, w, h, r), Wt = new Float32Array(N), sW = 0;
for (i = 0; i < N; i++) { v1[i] = Math.max(0, v1[i] - mu1[i] * mu1[i]); if (Mk[i]) { Wt[i] = Math.sqrt(v1[i]) + 2; sW += Wt[i]; } }
var W1 = w + 1, S = new Float64Array(W1 * (h + 1)), x, y;
for (y = 0; y < h; y++) for (x = 0; x < w; x++) S[(y + 1) * W1 + x + 1] = L[y * w + x] + S[y * W1 + x + 1] + S[(y + 1) * W1 + x] - S[y * W1 + x];
var memo = {};
function nota(n) {
if (memo[n] != null) return memo[n];
var sx = w / n, sy = sx * CH / CW, B = new Float32Array(N), B2 = new Float32Array(N), AB = new Float32Array(N);
for (y = 0; y < h; y++) {
var y0 = Math.min(h - 1, Math.floor(Math.floor(y / sy) * sy)), y1 = Math.min(h, Math.max(y0 + 1, Math.round(y0 + sy)));
for (x = 0; x < w; x++) {
var x0 = Math.min(w - 1, Math.floor(Math.floor(x / sx) * sx)), x1 = Math.min(w, Math.max(x0 + 1, Math.round(x0 + sx)));
var v = (S[y1 * W1 + x1] - S[y0 * W1 + x1] - S[y1 * W1 + x0] + S[y0 * W1 + x0]) / ((x1 - x0) * (y1 - y0)); i = y * w + x;
B[i] = v; B2[i] = v * v; AB[i] = v * ref[i];
}
}
var mu2 = suave(B, w, h, r), v2 = suave(B2, w, h, r), c = suave(AB, w, h, r), sum = 0;
for (i = 0; i < N; i++) if (Mk[i]) { var vv2 = Math.max(0, v2[i] - mu2[i] * mu2[i]), cc = c[i] - mu1[i] * mu2[i]; sum += Wt[i] * (2 * cc + C2) / (v1[i] + vv2 + C2); }
return (memo[n] = sum / sW);
}
T.nota = nota;
if (nota(nMin) >= tau) return nMin;
if (nota(nMax) < tau) return nMax;
var lo = nMin, hi = nMax;
while (hi - lo > 4) { var mid = Math.round((lo + hi) / 8) * 4; if (mid <= lo) mid = lo + 4; if (mid >= hi) break; if (nota(mid) >= tau) hi = mid; else lo = mid; }
return hi;
};
/* realza la imagen ya reducida a puntadas: estira el contraste y marca bordes (ojos, nariz, manchas) */
T.realzar = function (px, lista, cols, rows, fuerza) {
var n = lista.length, Ls = [], k, i;
if (!n) return;
for (k = 0; k < n; k++) Ls.push(px[lista[k] * 4] * .299 + px[lista[k] * 4 + 1] * .587 + px[lista[k] * 4 + 2] * .114);
var ord = Ls.slice().sort(function (a, b) { return a - b; }), lo = ord[Math.floor(n * .02)], hi = ord[Math.floor(n * .98)], esc = hi - lo > 20 ? 225 / (hi - lo) : 1;
var Lm = new Float32Array(cols * rows), dentro = new Uint8Array(cols * rows);
for (k = 0; k < n; k++) { Lm[lista[k]] = Ls[k]; dentro[lista[k]] = 1; }
var out = new Uint8ClampedArray(px);
for (k = 0; k < n; k++) {
var p = lista[k], X = p % cols, Y = (p / cols) | 0, s = 0, c = 0;
for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) { var q = (Y + dy) * cols + X + dx; if (X + dx >= 0 && X + dx < cols && Y + dy >= 0 && Y + dy < rows && dentro[q]) { s += Lm[q]; c++; } }
var L0 = Ls[k], L1 = (L0 - lo) * esc + 15, L2 = L1 + (L1 - ((s / c - lo) * esc + 15)) * (fuerza || .6), f = L0 > 1 ? L2 / L0 : 1;
for (i = 0; i < 3; i++) { var v = px[p * 4 + i], m = L0; out[p * 4 + i] = (m + (v - m) * 1.25) * f; }
}
for (i = 0; i < out.length; i++) px[i] = out[i];
};
T.mascota = function (ctx, img, cr, cx, cy, d, opt) {
opt = opt || {};
var A = K.A, b = A.cabeza(ctx, img, cr, cx, cy, d, !0), im = img || K.M.ejemploRecorte();
function pintar(x, ancho, alto, ox, oy, sw, sh) {
if (im.recorte) x.drawImage(im, (b.x - ox) / sw, (b.y - oy) / sh, b.w / sw, b.h / sh);
else { x.save(); x.scale(1 / sw, 1 / sh); x.translate(-ox, -oy); A.circulo(x, im, cr, cx, cy, d * .92); x.restore(); }
}
var nAncho = opt.puntadas, memo = im._sdrPaso || (im._sdrPaso = {}), clave = (cr && cr.s ? (+cr.s).toFixed(1) : "1") + "|" + (d | 0) + (im.recorte ? "r" : "c");
if (!nAncho) nAncho = memo[clave];
if (!nAncho) {
var R = 160, rs = b.w / R, Rh = Math.max(8, Math.round(b.h / rs)), ref = K.lienzo(R, Rh), rx = ref.getContext("2d");
rx.imageSmoothingQuality = "high"; pintar(rx, R, Rh, b.x, b.y, rs, rs);
var LM = T.lumMascara(rx.getImageData(0, 0, R, Rh).data, R, Rh);
nAncho = T.pasoIdeal(LM.L, LM.M, R, Rh, 28, 96, .8);
if (Object.keys(memo).length > 8) memo = im._sdrPaso = {};
memo[clave] = nAncho;
}
var w = Math.max(CW / 5, Math.min(CW / 1.3, b.w / nAncho)), h = w * CH / CW, cols = Math.ceil(b.w / w) + 2, rows = Math.ceil(b.h / h) + 2;
var x0 = Math.round((b.x - w) / w) * w, y0 = Math.round((b.y - h) / h) * h;
T.ultimo = { puntadas: Math.round(b.w / w) };
var c = K.lienzo(cols * 4, rows * 4), x = c.getContext("2d");
x.imageSmoothingQuality = "high"; pintar(x, cols * 4, rows * 4, x0, y0, w / 4, h / 4);
var s = K.lienzo(cols, rows), sx = s.getContext("2d"); sx.imageSmoothingQuality = "high"; sx.drawImage(c, 0, 0, cols, rows);
var px = sx.getImageData(0, 0, cols, rows).data, N = cols * rows, dentro = new Uint8Array(N), lista = [], i;
for (i = 0; i < N; i++) if (px[i * 4 + 3] > 110) { dentro[i] = 1; lista.push(i); }
T.realzar(px, lista, cols, rows, opt.realce);
var sub = new Uint8ClampedArray(lista.length * 4);
lista.forEach(function (p, k) { sub[k * 4] = px[p * 4]; sub[k * 4 + 1] = px[p * 4 + 1]; sub[k * 4 + 2] = px[p * 4 + 2]; });
var P = opt.colores ? paleta(sub, lista.length, opt.colores) : T.paletaIdeal(sub, lista.length, 6, 12), col = P.c.map(function (q) { return "rgb(" + (q[0] | 0) + "," + (q[1] | 0) + "," + (q[2] | 0) + ")"; });
T.ultimo.colores = P.c.length;
var borde = [];
for (i = 0; i < N; i++) {
if (dentro[i]) continue; var X = i % cols, Y = (i / cols) | 0, v = false;
for (var dy = -1; dy <= 1 && !v; dy++) for (var dx = -1; dx <= 1; dx++) { var xx = X + dx, yy = Y + dy; if (xx >= 0 && yy >= 0 && xx < cols && yy < rows && dentro[yy * cols + xx]) { v = true; break; } }
if (v) borde.push(i);
}
var todos = borde.concat(lista);
ctx.save(); ctx.fillStyle = "rgba(30,0,10,.32)"; todos.forEach(function (p) { ctx.fillRect(x0 + (p % cols) * w, y0 + ((p / cols) | 0) * h + h * .25, w, h); }); ctx.restore();
borde.forEach(function (p) { T.celda(ctx, x0 + (p % cols) * w, y0 + ((p / cols) | 0) * h, w, h, opt.borde || "#fff6ec"); });
lista.forEach(function (p, k) { T.celda(ctx, x0 + (p % cols) * w, y0 + ((p / cols) | 0) * h, w, h, col[P.asig[k]]); });
return b;
};
/* tipos de puntada: cada diseño teje con la suya (fondo, letras, gorro y la foto de la mascota) */
function f1(v) { return Math.round(v * 10) / 10; }
var PUNTOS = {
cruz: {
svg: function (x, y, s, c) { return '<path d="M' + f1(x + 5 * s) + ' ' + f1(y + 5 * s) + 'L' + f1(x + 19 * s) + ' ' + f1(y + 21 * s) + 'M' + f1(x + 19 * s) + ' ' + f1(y + 5 * s) + 'L' + f1(x + 5 * s) + ' ' + f1(y + 21 * s) + '" stroke="' + c + '" stroke-width="' + f1(6 * s) + '" stroke-linecap="round" fill="none"/>'; },
lienzo: function (ctx, X, Y, w, h, c) { var u = w / 24, v = h / 26; ctx.strokeStyle = c; ctx.lineWidth = 6 * u; ctx.lineCap = "round"; ctx.beginPath(); ctx.moveTo(X + 5 * u, Y + 5 * v); ctx.lineTo(X + 19 * u, Y + 21 * v); ctx.moveTo(X + 19 * u, Y + 5 * v); ctx.lineTo(X + 5 * u, Y + 21 * v); ctx.stroke(); }
},
arroz: {
svg: function (x, y, s, c) { return '<ellipse cx="' + f1(x + 12 * s) + '" cy="' + f1(y + 13 * s) + '" rx="' + f1(9.5 * s) + '" ry="' + f1(10.5 * s) + '" fill="' + c + '"/><circle cx="' + f1(x + 9 * s) + '" cy="' + f1(y + 9 * s) + '" r="' + f1(3 * s) + '" fill="#fff" opacity=".35"/>'; },
lienzo: function (ctx, X, Y, w, h, c) { var u = w / 24, v = h / 26; ctx.fillStyle = c; ctx.beginPath(); ctx.ellipse(X + 12 * u, Y + 13 * v, 9.5 * u, 10.5 * v, 0, 0, 7); ctx.fill(); ctx.fillStyle = "rgba(255,255,255,.35)"; ctx.beginPath(); ctx.arc(X + 9 * u, Y + 9 * v, 3 * u, 0, 7); ctx.fill(); }
},
canale: {
svg: function (x, y, s, c) { return '<rect x="' + f1(x + 5 * s) + '" y="' + f1(y + 1 * s) + '" width="' + f1(14 * s) + '" height="' + f1(24 * s) + '" rx="' + f1(7 * s) + '" fill="' + c + '"/><rect x="' + f1(x + 8 * s) + '" y="' + f1(y + 4 * s) + '" width="' + f1(3 * s) + '" height="' + f1(18 * s) + '" rx="' + f1(1.5 * s) + '" fill="#fff" opacity=".3"/>'; },
lienzo: function (ctx, X, Y, w, h, c) { var u = w / 24, v = h / 26; ctx.fillStyle = c; redondo(ctx, X + 5 * u, Y + v, 14 * u, 24 * v, 7 * u); ctx.fill(); ctx.fillStyle = "rgba(255,255,255,.3)"; redondo(ctx, X + 8 * u, Y + 4 * v, 3 * u, 18 * v, 1.5 * u); ctx.fill(); }
},
bobo: {
svg: function (x, y, s, c) { return '<rect x="' + f1(x + 1 * s) + '" y="' + f1(y + 5 * s) + '" width="' + f1(22 * s) + '" height="' + f1(16 * s) + '" rx="' + f1(8 * s) + '" fill="' + c + '"/><rect x="' + f1(x + 5 * s) + '" y="' + f1(y + 8 * s) + '" width="' + f1(14 * s) + '" height="' + f1(3 * s) + '" rx="' + f1(1.5 * s) + '" fill="#fff" opacity=".3"/>'; },
lienzo: function (ctx, X, Y, w, h, c) { var u = w / 24, v = h / 26; ctx.fillStyle = c; redondo(ctx, X + u, Y + 5 * v, 22 * u, 16 * v, 8 * u); ctx.fill(); ctx.fillStyle = "rgba(255,255,255,.3)"; redondo(ctx, X + 5 * u, Y + 8 * v, 14 * u, 3 * v, 1.5 * u); ctx.fill(); }
},
trenza: {
svg: function (x, y, s, c) { return '<ellipse cx="' + f1(x + 8 * s) + '" cy="' + f1(y + 13 * s) + '" rx="' + f1(5.5 * s) + '" ry="' + f1(12 * s) + '" transform="rotate(25 ' + f1(x + 8 * s) + ' ' + f1(y + 13 * s) + ')" fill="' + c + '"/><ellipse cx="' + f1(x + 16 * s) + '" cy="' + f1(y + 13 * s) + '" rx="' + f1(5.5 * s) + '" ry="' + f1(12 * s) + '" transform="rotate(25 ' + f1(x + 16 * s) + ' ' + f1(y + 13 * s) + ')" fill="' + c + '" opacity=".85"/>'; },
lienzo: function (ctx, X, Y, w, h, c) { var u = w / 24, v = h / 26; ctx.fillStyle = c; [8, 16].forEach(function (cx, k) { ctx.globalAlpha = k ? .85 : 1; ctx.beginPath(); ctx.ellipse(X + cx * u, Y + 13 * v, 5.5 * u, 12 * v, .44, 0, 7); ctx.fill(); }); ctx.globalAlpha = 1; }
}
};
function redondo(ctx, x, y, w, h, r) { ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(x, y, w, h, r); else ctx.rect(x, y, w, h); }
/* cambia la puntada solo mientras se dibuja este diseño */
function conPunto(tipo, fn) {
var P = PUNTOS[tipo]; if (!P) return fn;
return function () {
var pS = T.punto, pP = T.patron, pC = T.puntada;
T.punto = function (cx, cy, col, s) { s = s || 1; return P.svg(cx * CW * s, cy * CH * s, s, col); };
T.patron = function (id, base, claro, oscuro) { return '<pattern id="' + id + '" width="' + CW + '" height="' + CH + '" patternUnits="userSpaceOnUse"><rect width="' + CW + '" height="' + CH + '" fill="' + oscuro + '"/>' + P.svg(0, 0, 1, base) + '</pattern>'; };
T.puntada = function (ctx, X, Y, w, h, col) { P.lienzo(ctx, X, Y, w, h, col); };
try { return fn.apply(this, arguments); } finally { T.punto = pS; T.patron = pP; T.puntada = pC; }
};
}
T.PUNTOS = PUNTOS; T.conPunto = conPunto;
T.PUNTADAS = [["v", "Jersey"], ["cruz", "Punto de cruz"], ["arroz", "Punto arroz"], ["canale", "Canalé"], ["bobo", "Punto bobo"], ["trenza", "Trenzado"]];
})(this);